import { ShimmeredDetailsListProps } from "@bps/fluent-ui";
import { FieldDeviceRoleType } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { BaseTenantDeplomentRings } from "./BaseTenantDeploymentRings";

interface ClientDeploymentRingsProps extends ShimmeredDetailsListProps {
  tenant: Tenant;
}

export const ClientDeploymentRings = ({
  items,
  ...props
}: ClientDeploymentRingsProps) => {
  const fieldDeviceRoleType = FieldDeviceRoleType.Client;

  const clientDeploymentRings = items?.filter(
    val => val.fieldDeviceRoleTypeSid === fieldDeviceRoleType
  );

  return (
    <BaseTenantDeplomentRings
      fieldDeviceRoleType={fieldDeviceRoleType}
      heading="Client Deployment Ring"
      items={clientDeploymentRings}
      {...props}
    />
  );
};
